import { RequestOptionsService } from "./requestOptions";
import request from "request-promise";

export class DeviceOptionsService {
  public static async updateDeviceOptions(deviceUdid, userDefault) {
    const options = RequestOptionsService.postBrearerOptions(`PaymentMethods/${deviceUdid}`, {
      Items: userDefault
    });
    const result = await request(options);
    return result;
  }
}
